<script setup>
import Layout from "../../layouts/main.vue";
import mushroom from "cem-primary-api";
import { onMounted, ref, nextTick } from "vue";
import { langWeb } from "../../stores/lang";

const lang_web = langWeb();
const containerRef = ref(null);
const status = ref("loading");

const fetchLicense = async () => {
  try {
    const response = await mushroom.license.getLicenseAsync({});
    return JSON.parse(response.result);
  } catch (e) {
    console.error("Error: ", e);
    return null;
  }
};

const loadLicense = async () => {
  status.value = "loading";
  const data = await fetchLicense();
  if (data) {
    const lang = lang_web.showLang === "en" ? "template_en" : "template_vi";
    const html = data[lang] || data.template_vi || data.template_en;
    if (html) {
      status.value = "success";
      await nextTick();
      const shadow = containerRef.value.attachShadow({ mode: "open" });
      shadow.innerHTML = html;
      return;
    }
  }
  status.value = "error";
};

const retryFetch = () => loadLicense();

onMounted(() => loadLicense());
</script>

<template>
  <Layout>
    <div class="license-page">
      <div v-if="status === 'loading'" class="loading-wrapper">
        <div class="spinner"></div>
        <span>{{ $t("t_loading_license") }}</span>
      </div>
      <div
        v-else-if="status === 'success'"
        ref="containerRef"
        class="license-container"
      ></div>
      <div v-else class="error-wrapper">
        <div class="error-icon">
          <i class="ri-error-warning-line"></i>
        </div>
        <p class="error-title">{{ $t("t_error_loading_license") }}</p>
        <p class="error-desc">{{ $t("t_error_loading_license_desc") }}</p>
        <button class="btn btn-soft-secondary btn-border" @click="retryFetch">
          <i class="ri-refresh-line me-1"></i>{{ $t("t_retry") }}
        </button>
      </div>
    </div>
  </Layout>
</template>

<style scoped lang="scss">
.license-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 200px);
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #64748b;
  font-size: 14px;
}

.error-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  button {
    display: flex;
    align-items: center;
  }
}

.error-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: var(--vz-danger);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.error-icon i {
  font-size: 28px;
  color: var(--vz-light);
}

.error-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.error-desc {
  font-size: 13px;
  color: var(--vz-gray-600);
  margin-bottom: 4px;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top-color: var(--vz-secondary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
